var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _TheCommand_instances, _TheCommand_pluginOptions, _TheCommand_stateShared, _TheCommand_API, _TheCommand_executeSetState, _TheCommand_executeCreateWidget;
import { Command } from '@ckeditor/ckeditor5-core';
var ETypeCommand;
(function (ETypeCommand) {
    ETypeCommand["CreateWidget"] = "createWidget";
    ETypeCommand["GetAPI"] = "getAPI";
    ETypeCommand["SetState"] = "setState";
})(ETypeCommand || (ETypeCommand = {}));
export class TheCommand extends Command {
    constructor() {
        super(...arguments);
        _TheCommand_instances.add(this);
        _TheCommand_pluginOptions.set(this, void 0);
        _TheCommand_stateShared.set(this, void 0);
        this.setState = ({ pluginOptions, stateShared, }) => {
            __classPrivateFieldSet(this, _TheCommand_pluginOptions, pluginOptions, "f");
            __classPrivateFieldSet(this, _TheCommand_stateShared, stateShared, "f");
        };
        _TheCommand_API.set(this, {
            getStateShared: () => {
                if (__classPrivateFieldGet(this, _TheCommand_stateShared, "f")) {
                    return __classPrivateFieldGet(this, _TheCommand_stateShared, "f");
                }
                throw new Error('this.#stateShared is not initialized.');
            },
        });
    }
    execute({ payload, type, }) {
        switch (type) {
            case ETypeCommand.CreateWidget:
                __classPrivateFieldGet(this, _TheCommand_instances, "m", _TheCommand_executeCreateWidget).call(this, payload);
                return undefined;
            case ETypeCommand.GetAPI:
                return __classPrivateFieldGet(this, _TheCommand_API, "f");
            case ETypeCommand.SetState:
                __classPrivateFieldGet(this, _TheCommand_instances, "m", _TheCommand_executeSetState).call(this, payload);
                return undefined;
            default:
                throw new Error(`unknown command type: ${type}`);
        }
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    refresh() {
        var _a;
        const model = this.editor.model;
        const selection = model.document.selection;
        const firstPosition = selection.getFirstPosition();
        if (firstPosition) {
            const allowedIn = model.schema.findAllowedParent(firstPosition, ((_a = __classPrivateFieldGet(this, _TheCommand_pluginOptions, "f")) === null || _a === void 0 ? void 0 : _a.options.nameWidget) || '');
            this.isEnabled = allowedIn !== null;
        }
    }
}
_TheCommand_pluginOptions = new WeakMap(), _TheCommand_stateShared = new WeakMap(), _TheCommand_API = new WeakMap(), _TheCommand_instances = new WeakSet(), _TheCommand_executeSetState = function _TheCommand_executeSetState(data) {
    var _a;
    (_a = __classPrivateFieldGet(this, _TheCommand_stateShared, "f")) === null || _a === void 0 ? void 0 : _a.state.set(data.ID, Object.assign({ editor: this.editor }, data));
}, _TheCommand_executeCreateWidget = function _TheCommand_executeCreateWidget(data) {
    this.editor.model.change((writer) => {
        var _a, _b;
        if (typeof data.hasRendered !== 'boolean') {
            data.hasRendered = false;
        }
        __classPrivateFieldGet(this, _TheCommand_instances, "m", _TheCommand_executeSetState).call(this, data);
        const element = writer.createElement(((_a = __classPrivateFieldGet(this, _TheCommand_pluginOptions, "f")) === null || _a === void 0 ? void 0 : _a.options.nameWidget) || '', {
            id: data.ID,
            'widget-name': (_b = __classPrivateFieldGet(this, _TheCommand_pluginOptions, "f")) === null || _b === void 0 ? void 0 : _b.options.nameWidget,
        });
        // Insert <TheWidget id="...">*</TheWidget> at the current selection position
        // in a way which will result in creating a valid model structure.
        this.editor.model.insertContent(element);
        writer.setSelection(element, 'after');
    });
};
